import apiClient from 'services/axios'

// eslint-disable-next-line import/prefer-default-export
export async function getSalesAgentById(agentId) {
  try {
    const response = await apiClient.get(`agent/${agentId}/full`)
    return response.data
  } catch (err) {
    console.error(`Fetch Sales Agent ${agentId} failed`, err)
    throw err
  }
}

export async function getMonthlyAgentCommission(agentId, month, year, includeDetails = false) {
  try {
    const response = await apiClient.get(`agent/sales-agent/${agentId}/monthly-commission`, {
      params: { month, year, includeDetails: includeDetails.toString() },
    })
    return response.data
  } catch (err) {
    console.error('Fetch Monthly Agent Commission failed', err)
    throw err
  }
}

export async function getYearlyAgentCommission(agentId, year) {
  try {
    const response = await apiClient.get(`agent/sales-agent/${agentId}/yearly-commission`, {
      params: { year },
    })
    return response.data
  } catch (err) {
    console.error('Fetch Yearly Agent Commission failed', err)
    throw err
  }
}

export async function getRateDetails(businessId) {
  return apiClient
    .get(`/agent/business/${businessId}/rates`)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function getSubAgents(agentId) {
  return apiClient
    .get(`/agent/${agentId}/sub-agents`)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function createSubAgent(agentId, data) {
  return apiClient
    .post(`/agent/${agentId}/sub-agents`, data)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function assignMerchantToSubAgent(agentId, subAgentId, data) {
  return apiClient
    .post(`/agent/${agentId}/sub-agents/${subAgentId}/assign`, data)
    .then(response => response.data)
    .catch(err => console.log(err))
}

export async function getAgentPayouts(agentId) {
  return apiClient
    .get(`/agent/${agentId}/payouts`)
    .then(response => response.data)
    .catch(err => console.log(err))
}
